export default __webpack_public_path__ + "static/media/HV_Icones_Staging_white.5b972a5f.svg";